// ----------------------------------------------------------------------------
// Создает HTML-элемент с заданными параметрами.
// @param {string} tag - Тип тега (например, 'div', 'button').
// @param {Object} props - Объект с атрибутами (classes, data, type и т.д.).
// @param {...(Node|string)} children - Вложенные элементы или текст.
// @returns {HTMLElement}

// Пример создания элемента
// createElement('button', {
//     onclick: () => alert('Добавлено!'),
//     class: 'buy-btn'
//   }, 'Купить')
//
// createElement('h3', {}, 'iPhone 15'),
// createElement('p', { class: 'price' }, '999$'),
// const aElement = createElement('a', { class: 'table-of-content__item', data: {id: 'anchor' + counter} }, text.trim());
// ----------------------------------------------------------------------------


/**
 * * Создает HTML-элемент с заданными свойствами и дочерними узлами.
 *  * Умеет обрабатывать классы (включая массивы), дата-атрибуты и назначать обработчики событий (например, onClick).
 *  *
 *  * @param {string} tag - Имя создаваемого тега (например, 'div', 'button', 'a')
 *  * @param {Object<string, any>} [props={}] - Объект атрибутов (className, dataset, события on* и стандартные атрибуты)
 *  * @param {...(string|Node)} children - Дочерние узлы. Могут быть строками (превратятся в TextNode) или DOM-узлами
 *  * @returns {HTMLElement} - Готовый DOM-элемент
 */

const createElement = (tag, props = {}, ...children) => {
    const element = document.createElement(tag);

    Object.entries(props).forEach(([key, value]) => {
        // передали классы
        if (key === 'className' || key === 'class') {
            if (Array.isArray(value)) {
                element.classList.add(...value.filter(Boolean)); // на случай, если в массив попали false-значения (например вот так: const classes = ['btn', isActive ? 'active' : null];)
            } else {
                element.className = value;
            }
            // передали дата-атрибуты
        } else if (key === 'dataset' || key === 'data') {
            Object.entries(value).forEach(([dataKey, dataValue]) => {
                element.dataset[dataKey] = dataValue;
            });
            // Добавление событий (например, onClick -> click)
        } else if (key.startsWith('on') && typeof value === 'function') {
            const eventName = key.toLowerCase().substring(2);
            element.addEventListener(eventName, value);
            // Все остальные атрибуты (id, type, value, href...)
        } else {
            element.setAttribute(key, value);
        }
    });

    // Добавление контента или дочерних узлов
    children.forEach(child => {
        if (typeof child === 'string') {
            element.appendChild(document.createTextNode(child));
        } else if (child instanceof Node) {
            element.appendChild(child);
        }
    });

    return element;
};


export default createElement;